export default () => ({
  isBusy: false,
  STRIPE_PUBLISHABLE_KEY: "",
  carouselImages: [],
  flags: [],
})
